import React from 'react';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import styled from 'App/styled';
import ProgressBar from './ProgressBar';
import { RATING_POPUP_CLASS } from 'shared/constants/productPage';

export interface ReviewSplitUp {
  count: string;
  per: number;
  id: number;
}
interface RatingCountPopUpProps {
  reviewSplitUp?: ReviewSplitUp[];
  rating: number;
}
const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted ${({ theme }) => theme.colors.state};
`;

const Content = styled.div`
  ${({ theme }) => theme.borders.border100};
  border-radius: ${({ theme }) => theme.borders.radius10};
  border-color: ${({ theme }) => hexToRgb(theme.colors.state, 0.22)};
  visibility: hidden;
  min-width: 240px;
  background-color: ${({ theme }) => theme.colors.white};
  text-align: center;
  border-radius: ${({ theme }) => theme.borders.radius20};
  padding: ${({ theme }) => theme.spacing.spacing60};
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -180px;
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent
      ${({ theme }) => hexToRgb(theme.colors.state, 0.22)} transparent;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -9px;
    border-width: 9px;
    border-style: solid;
    border-color: transparent transparent ${({ theme }) => theme.colors.white}
      transparent;
  }
`;
const Hading = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  line-height: unset;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.7)};

  span {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;
const RatingCountPopUp = ({ reviewSplitUp, rating }: RatingCountPopUpProps) => (
  <Wrapper>
    <Content className={RATING_POPUP_CLASS}>
      <Hading>
        Rating(s)
        <span>{rating} out of 5 stars</span>
      </Hading>
      {reviewSplitUp?.map((ele) => (
        <ProgressBar
          key={'progress' + ele?.id}
          count={ele?.count}
          id={ele?.id}
          per={ele?.per}
        />
      ))}
    </Content>
  </Wrapper>
);

export default RatingCountPopUp;
